import { AbstractFacade } from '@goparrot/common';
import { plainToClass } from 'class-transformer';
import deepmerge from 'deepmerge';
import { ReadRoleV2Dto } from '../generated-dto';
import { RoleV2ExposeGroup } from '../interface';
export class RoleV2ByMerchantFacade extends AbstractFacade {
    constructor(config = {}, interceptors = {}) {
        super(deepmerge.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_USER,
                },
            },
            config,
        ]), interceptors);
        this.baseURL = 'api/v2/merchants';
    }
    async list(merchantId) {
        return plainToClass(ReadRoleV2Dto, (await this.client.get(`${this.baseURL}/${encodeURIComponent(merchantId)}/roles`)).data, {
            groups: [RoleV2ExposeGroup.READ],
        });
    }
    async get(merchantId, roleV2Uuid) {
        return plainToClass(ReadRoleV2Dto, (await this.client.get(`${this.baseURL}/${encodeURIComponent(merchantId)}/roles/${encodeURIComponent(roleV2Uuid)}`)).data, {
            groups: [RoleV2ExposeGroup.READ],
        });
    }
    async create(merchantId, data) {
        return plainToClass(ReadRoleV2Dto, (await this.client.post(`${this.baseURL}/${encodeURIComponent(merchantId)}/roles`, data)).data, {
            groups: [RoleV2ExposeGroup.READ],
        });
    }
    async patch(merchantId, roleV2Uuid, data) {
        return plainToClass(ReadRoleV2Dto, (await this.client.patch(`${this.baseURL}/${encodeURIComponent(merchantId)}/roles/${encodeURIComponent(roleV2Uuid)}`, data)).data, {
            groups: [RoleV2ExposeGroup.READ],
        });
    }
    async delete(merchantId, roleV2Uuid) {
        await this.client.delete(`${this.baseURL}/${encodeURIComponent(merchantId)}/roles/${encodeURIComponent(roleV2Uuid)}`);
    }
}
//# sourceMappingURL=RoleV2ByMerchantFacade.js.map